var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manager_dashboard" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("MentorSidebarMenu", {
            attrs: { show_menu: true, show_back_button: false }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content-wrapper",
              staticStyle: { "padding-left": "165px" }
            },
            [
              _c("div", { staticClass: "container-wrapper center" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 p-0 pl-2" }, [
                    _c("h3", { staticClass: "heading text-uppercase mb-3" }, [
                      _vm._v(_vm._s(_vm.accountName))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-7 pr-3 pr-xl-5" },
                    [
                      _vm.menteeCountLoading == true
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "row justify-content-between custom-pl-15 pb-4"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "col pl-0 pr-2" },
                                [
                                  _c("PuSkeleton", {
                                    attrs: { height: "150px", count: 1 }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col pl-4" },
                                [
                                  _c("PuSkeleton", {
                                    attrs: { height: "150px", count: 1 }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col pl-4 pr-1" },
                                [
                                  _c("PuSkeleton", {
                                    attrs: { height: "150px", count: 1 }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.menteeCountLoading == false
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "row justify-content-between custom-pl-15"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "col pl-0 pr-xl-4 pr-lg-2" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "shadow p-3 information_box"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "information_box_title"
                                        },
                                        [_vm._v("Mentees")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "h3" }, [
                                        _vm._v(_vm._s(_vm.menteeCount))
                                      ]),
                                      _vm._v(" "),
                                      _vm.ticker == "Up"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "small px-2 py-1 information_box_text_up"
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "mr-1 stats_icon",
                                                attrs: {
                                                  src: require("@/assets/manager/up_tick_icon.png")
                                                }
                                              }),
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(_vm.tickerText)
                                              )
                                            ]
                                          )
                                        : _vm.ticker == "Down"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "small px-2 py-1 information_box_text_down"
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "mr-1 stats_icon",
                                                attrs: {
                                                  src: require("@/assets/manager/down_tick_icon.png")
                                                }
                                              }),
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(_vm.tickerText)
                                              )
                                            ]
                                          )
                                        : _vm.ticker == "" &&
                                          _vm.tickerText != ""
                                        ? _c(
                                            "span",
                                            { staticClass: "small px-2 py-1 " },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(_vm.tickerText)
                                              )
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            { staticClass: "small px-2 py-1" },
                                            [_vm._v(" ")]
                                          )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col px-xl-4 px-lg-2",
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.openAccountRepToReviewModal()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "shadow p-3 information_box"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "information_box_title"
                                        },
                                        [_vm._v("Reps to Review")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "h3" }, [
                                        _vm._v(_vm._s(_vm.repsReviewCount))
                                      ]),
                                      _vm._v(" "),
                                      _vm.previousWeekRepCount <
                                      _vm.currentWeekRepCount
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "small px-2 py-1 information_box_text_up"
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "mr-1 stats_icon",
                                                attrs: {
                                                  src: require("@/assets/manager/up_tick_icon.png")
                                                }
                                              }),
                                              _vm._v(
                                                "\n                      Up " +
                                                  _vm._s(
                                                    parseInt(
                                                      _vm.currentWeekRepCount -
                                                        _vm.previousWeekRepCount
                                                    )
                                                  ) +
                                                  " this week"
                                              )
                                            ]
                                          )
                                        : _vm.previousWeekRepCount >
                                          _vm.currentWeekRepCount
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "small px-2 py-1 information_box_text_down"
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "mr-1 stats_icon",
                                                attrs: {
                                                  src: require("@/assets/manager/down_tick_icon.png")
                                                }
                                              }),
                                              _vm._v(
                                                "\n                      Down " +
                                                  _vm._s(
                                                    parseInt(
                                                      _vm.previousWeekRepCount -
                                                        _vm.currentWeekRepCount
                                                    )
                                                  ) +
                                                  " this week"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            { staticClass: "small px-2 py-1" },
                                            [_vm._v(" ")]
                                          )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col pl-xl-4 pl-lg-2 pr-0",
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.competencyReport()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "shadow p-3 information_box"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "information_box_title"
                                        },
                                        [_vm._v("Competencies")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "h3" }, [
                                        _vm._v(
                                          _vm._s(_vm.currentWeekCompetencyCount)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.previousWeekCompetencyCount <
                                      _vm.currentWeekCompetencyCount
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "small px-2 py-1 information_box_text_up"
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "mr-1 stats_icon",
                                                attrs: {
                                                  src: require("@/assets/manager/up_tick_icon.png")
                                                }
                                              }),
                                              _vm._v(
                                                "\n                      Up " +
                                                  _vm._s(
                                                    parseInt(
                                                      _vm.currentWeekCompetencyCount -
                                                        _vm.previousWeekCompetencyCount
                                                    )
                                                  ) +
                                                  " this week"
                                              )
                                            ]
                                          )
                                        : _vm.previousWeekCompetencyCount >
                                          _vm.currentWeekCompetencyCount
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "small px-2 py-1 information_box_text_down"
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "mr-1 stats_icon",
                                                attrs: {
                                                  src: require("@/assets/manager/down_tick_icon.png")
                                                }
                                              }),
                                              _vm._v(
                                                "\n                      Down " +
                                                  _vm._s(
                                                    parseInt(
                                                      _vm.previousWeekCompetencyCount -
                                                        _vm.currentWeekCompetencyCount
                                                    )
                                                  ) +
                                                  " this week"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            { staticClass: "small px-2 py-1" },
                                            [_vm._v(" ")]
                                          )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("DashboardMenteesList", {
                        ref: "DashboardMenteesList",
                        on: { openRepToReviewModal: _vm.openRepToReviewModal }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-5 pl-4 pl-xl-4 pr-3 pr-xl-5" },
                    [
                      _vm.checklistLoading == false &&
                      _vm.checklistCompleteFlag == 0
                        ? _c(
                            "div",
                            [_c("MentorChecklist", { ref: "MentorChecklist" })],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 mb-3 p-0" }, [
                        _c("div", { staticClass: "shadow rounded px-2 py-1" }, [
                          _c("div", { staticClass: "h4 mt-1 mb-1" }, [
                            _vm._v("Reports")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "row justify-content-center mb-3" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "text-muted",
                                  attrs: {
                                    to: { name: "pathwayprogressreports" }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "report-panel rounded text-center p-1 text-muted",
                                      staticStyle: {
                                        "border-color": "#002F42 !important"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "25px",
                                          "margin-top": "5px",
                                          "margin-bottom": "5px"
                                        },
                                        attrs: {
                                          src: require("@/assets/manager/Mentor Mentee Progress Report Icon.png")
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "mb-0 small",
                                          staticStyle: { color: "#002F42" }
                                        },
                                        [_vm._v("Progress")]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass: "text-muted",
                                  attrs: { to: { name: "competencyreport" } }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "report-panel rounded text-center p-1 text-muted",
                                      staticStyle: {
                                        "border-color": "#002F42 !important"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "19px",
                                          "margin-top": "5px",
                                          "margin-bottom": "5px"
                                        },
                                        attrs: {
                                          src: require("@/assets/manager/competency_report_icon.png")
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "mb-0 small",
                                          staticStyle: { color: "#002F42" }
                                        },
                                        [_vm._v("Competency")]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass: "text-muted",
                                  attrs: { to: { name: "mentorUsageReports" } }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "report-panel rounded text-center p-1 text-muted",
                                      staticStyle: {
                                        "border-color": "#002F42 !important",
                                        "margin-right": "0px !important"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "25px",
                                          "margin-top": "5px",
                                          "margin-bottom": "8px"
                                        },
                                        attrs: {
                                          src: require("@/assets/manager/usage_report_icon.png")
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "mb-0 small",
                                          staticStyle: { color: "#002F42" }
                                        },
                                        [_vm._v("Usage")]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass: "text-muted",
                                  attrs: { to: { name: "repaudittrail" } }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "report-panel rounded text-center p-1 text-muted",
                                      staticStyle: {
                                        "border-color": "#002F42 !important"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "22px",
                                          "margin-top": "5px",
                                          "margin-bottom": "10px"
                                        },
                                        attrs: {
                                          src: require("@/assets/manager/tasks_icon_rep_audit_trail.png")
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "mb-0 small",
                                          staticStyle: { color: "#002F42" }
                                        },
                                        [_vm._v("Tasks")]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-12 p-0",
                          staticStyle: { "padding-top": "22px !important" }
                        },
                        [_c("DashboardNotifications")],
                        1
                      )
                    ]
                  )
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("MenteeRepsToReview", {
        ref: "MenteeRepsToReview",
        attrs: { isReptoReviewModalVisible: _vm.isReptoReviewModalVisible },
        on: {
          close: _vm.closeRepToReviewModal,
          closeRepToReviewModal: _vm.closeRepToReviewModal,
          reduceRepCount: _vm.reduceRepCount
        }
      }),
      _vm._v(" "),
      _vm.introduction_slide_obj.length > 0
        ? _c(
            "div",
            {
              staticClass: "fixed-bell-icon btn btn-primary",
              on: { click: _vm.showIntroductionSlide }
            },
            [
              _c("i", {
                staticClass: "fa fa-bell",
                attrs: { "aria-hidden": "true" }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("IntroductionModal", {
        ref: "introduction_modal",
        attrs: {
          isIntroductionModalVisible: _vm.isIntroductionModalVisible,
          introductionSlideObj: _vm.introduction_slide_obj,
          showSlideNumbers: _vm.showSlideNumbers
        },
        on: {
          goToAssessmentLanding: _vm.goToAssessmentLanding,
          close: function($event) {
            _vm.isIntroductionModalVisible = false
          }
        }
      }),
      _vm._v(" "),
      _c("MenteeAssessmentLandingPage", {
        ref: "MenteeAssessmentLandingModal",
        attrs: { isModalVisible: _vm.isAssessmentLandingVisible },
        on: {
          closeAssessmentLandingModal: _vm.closeAssessmentLandingModal,
          openAssessmentQuestionModal: _vm.openAssessmentQuestionModal
        }
      }),
      _vm._v(" "),
      _c("MenteeAssessmentQuestionPage", {
        ref: "MenteeAssessmentQuestionModal",
        attrs: { isModalVisible: _vm.isAssessmentQuestionVisible },
        on: { closeAssessmentQuestionModal: _vm.closeAssessmentQuestionModal }
      }),
      _vm._v(" "),
      _c("AccountRepsToReview", {
        ref: "AccountRepsToReview",
        attrs: {
          isReptoReviewModalVisible: _vm.isAccountReptoReviewModalVisible
        },
        on: {
          close: _vm.closeAccountRepToReviewModal,
          closeAccountRepToReviewModal: _vm.closeAccountRepToReviewModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53781707", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53781707","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mentor/mentor_dashboard_v2.vue
// module id = null
// module chunks = 